module.exports = __webpack_public_path__ + "img/disabledarrow.be556903.svg";